module.exports = __webpack_public_path__ + "static/references-d405dff4a91bc9c3164893ba943a2c4d.svg";